import { useWidgetAlertStore } from '@widgets/messenger/stores/useWidgetAlertStore'
import type { MessengerAlert, MessengerAlertScope } from '@widgets/messenger/types/alert'
import type { MaybeRefOrGetter } from '@/composition/vue/compositionApi'
import { computed, toValue } from '@/composition/vue/compositionApi'

export const useWidgetAlerts = (scopes: MaybeRefOrGetter<MessengerAlertScope[]>) => {
  const scopesRef = computed(() => toValue(scopes))

  const { alerts, addAlert, removeAlert, removeAlertBy } = useWidgetAlertStore()

  const scopedAlerts = computed(() => alerts.value.filter((alert) => scopesRef.value.includes(alert.scope)))
  const lastAddedAlert = computed<MessengerAlert | undefined>(() =>
    scopedAlerts.value.length ? scopedAlerts.value[scopedAlerts.value.length - 1] : undefined,
  )

  return {
    visibleAlert: lastAddedAlert,
    addAlert,
    removeAlert,
    removeAlertBy,
  }
}
